import React, { useEffect } from "react";

import { useAuthenticator } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import { signInWithRedirect } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";

import { useAuthenticationContext } from "@context/authentication";

import { amplifyConfig } from "../../config/amplify";
import { ROUTES } from "../../routes";

export const InternalSignIn = () => {
  const { authStatus } = useAuthenticator((context) => [context.user]);
  const providerName = process.env.REACT_APP_INTERNAL_USER_POOL_PROVIDER_NAME;

  const auth = useAuthenticationContext();
  const navigate = useNavigate();

  useEffect(() => {
    // if is authenticated, navigate to dashboard
    if (auth?.auth) {
      navigate(ROUTES.Dashboard.path);
    } else {
      // otherwise set-up internal amplify config, the authStatus would be configuring
      Amplify.configure(amplifyConfig.internal);
      // after authStatus changed to unauthenticated, pop the Okta login
      if (authStatus === "unauthenticated" && providerName) {
        signInWithRedirect({
          provider: {
            custom: providerName,
          },
        });
      }
    }
  }, [auth, authStatus, navigate, providerName]);
  return <></>;
};
